//#region src/errors.ts
var ErrorCode = {
	DI_DUPLICATE_REGISTRATION: "DI_DUPLICATE_REGISTRATION",
	DI_MISSING_DEPENDENCY: "DI_MISSING_DEPENDENCY",
	DI_CIRCULAR_DEPENDENCY: "DI_CIRCULAR_DEPENDENCY",
	SDK_DUPLICATE_DOMAIN: "SDK_DUPLICATE_DOMAIN",
	SDK_MISSING_DOMAIN: "SDK_MISSING_DOMAIN",
	COMPOSITION_MISSING_MANIFEST: "COMPOSITION_MISSING_MANIFEST",
	COMPOSITION_DUPLICATE_FEATURE: "COMPOSITION_DUPLICATE_FEATURE",
	COMPOSITION_SERVICE_COLLISION: "COMPOSITION_SERVICE_COLLISION",
	COMPOSITION_DOMAIN_COLLISION: "COMPOSITION_DOMAIN_COLLISION",
	COMPOSITION_NAMESPACE_COLLISION: "COMPOSITION_NAMESPACE_COLLISION",
	COMPOSITION_MISSING_SERVICE: "COMPOSITION_MISSING_SERVICE",
	COMPOSITION_MISSING_DOMAIN: "COMPOSITION_MISSING_DOMAIN",
	CONFIG_INVALID_VALUE: "CONFIG_INVALID_VALUE",
	CONFIG_MISSING_VALUE: "CONFIG_MISSING_VALUE",
	HTTP_REQUEST_FAILED: "HTTP_REQUEST_FAILED",
	HTTP_TIMEOUT: "HTTP_TIMEOUT",
	HTTP_NETWORK_ERROR: "HTTP_NETWORK_ERROR",
	HTTP_PARSE_ERROR: "HTTP_PARSE_ERROR",
	AUTH_UNAUTHENTICATED: "AUTH_UNAUTHENTICATED",
	AUTH_FORBIDDEN: "AUTH_FORBIDDEN",
	FEATURE_INVALID_OPTIONS: "FEATURE_INVALID_OPTIONS",
	FEATURE_UNSUPPORTED_PROVIDER: "FEATURE_UNSUPPORTED_PROVIDER",
	ENGINE_MISSING_FACTORY: "ENGINE_MISSING_FACTORY",
	ENGINE_MISSING_COMPONENT: "ENGINE_MISSING_COMPONENT",
	ENGINE_INVALID_HANDLE: "ENGINE_INVALID_HANDLE",
	ENGINE_FACTORY_UNSET: "ENGINE_FACTORY_UNSET",
	MAPPER_INVALID_TYPE: "MAPPER_INVALID_TYPE",
	MAPPER_DUPLICATE_REGISTRATION: "MAPPER_DUPLICATE_REGISTRATION"
};
var AppError = class extends Error {
	constructor(options) {
		super(options.message);
		this.name = "AppError";
		this.code = options.code;
		this.hint = options.hint;
		this.metadata = options.metadata;
		this.retryable = options.retryable ?? false;
		this.httpStatus = options.httpStatus ?? 500;
		if (options.cause !== void 0) Object.defineProperty(this, "cause", {
			configurable: true,
			enumerable: false,
			value: options.cause,
			writable: true
		});
	}
	toJSON() {
		return {
			name: this.name,
			code: this.code,
			message: this.message,
			hint: this.hint,
			metadata: this.metadata,
			retryable: this.retryable,
			httpStatus: this.httpStatus
		};
	}
	toSafeResponse() {
		return {
			code: this.code,
			message: this.message,
			retryable: this.retryable
		};
	}
};
function isAppError(error) {
	return error instanceof AppError;
}
function toAppError(error, fallbackCode) {
	if (isAppError(error)) return error;
	return new AppError({
		code: fallbackCode,
		message: error instanceof Error ? error.message : String(error),
		cause: error
	});
}
//#endregion
export { AppError, ErrorCode, isAppError, toAppError };

//# sourceMappingURL=errors.js.map